
import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingSocialIcons from '../../components/base/FloatingSocialIcons';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-50 relative overflow-hidden">
      <FloatingSocialIcons />
      <Header />
      
      <main className="relative z-10">
        <section className="py-20 px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent text-center">
              Privacy Policy
            </h1>
            <p className="text-center text-gray-600 mb-12">Last Updated: January 2024</p>

            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">1. Introduction</h2>
                <p className="text-gray-700 leading-relaxed">
                  Welcome to Digital Experience Studio. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">2. Information We Collect</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We may collect, use, store and transfer different kinds of personal data about you:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Identity Data: first name, last name, business name</li>
                  <li>Contact Data: email address, telephone numbers, business address</li>
                  <li>Technical Data: IP address, browser type, time zone setting, browser plug-in types and versions</li>
                  <li>Usage Data: information about how you use our website and services</li>
                  <li>Marketing and Communications Data: your preferences in receiving marketing from us</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">3. How We Use Your Information</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>To provide and deliver our services to you</li>
                  <li>To respond to your inquiries and fulfill your requests</li>
                  <li>To send you marketing communications (with your consent)</li>
                  <li>To improve our website and services</li>
                  <li>To comply with legal obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">4. Data Security</h2>
                <p className="text-gray-700 leading-relaxed">
                  We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. We limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">5. Data Retention</h2>
                <p className="text-gray-700 leading-relaxed">
                  We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">6. Your Legal Rights</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Under certain circumstances, you have rights under data protection laws in relation to your personal data:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Request access to your personal data</li>
                  <li>Request correction of your personal data</li>
                  <li>Request erasure of your personal data</li>
                  <li>Object to processing of your personal data</li>
                  <li>Request restriction of processing your personal data</li>
                  <li>Request transfer of your personal data</li>
                  <li>Right to withdraw consent</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">7. Third-Party Links</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">8. Contact Us</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  If you have any questions about this privacy policy or our privacy practices, please contact us:
                </p>
                <div className="bg-blue-50 rounded-xl p-6">
                  <p className="text-gray-700">
                    <strong>Email:</strong> privacy@socialswingstudio.com<br />
                    <strong>Phone:</strong> (555) 123-4567
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">9. Changes to This Policy</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last Updated" date at the top of this policy.
                </p>
              </section>
            </div>

            <div className="mt-12 text-center">
              <Link
                to="/contact"
                className="inline-block bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Contact Us About Privacy
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
